<template>
  <InsideContent
    :title="$t('ADVERTISEMENT.CAMPAIGN_DETAILS.BIDS_LIST.TITLE')"
    class="bids"
  >
    <Card v-if="isLoading && !data.length" :is-loading="isLoading" />
    <CardApiError
      v-else-if="apiError"
      :error-text="$t('ADVERTISEMENT.BIDS.API_ERROR')"
      @retry="getBids"
    />
    <Transition v-else name="fade-transform" mode="out-in">
      <BidsContent
        v-if="isLoading || data.length"
        v-loading="isLoading"
        :range.sync="filters.range"
        @update:range="getBids"
        @update="getBids"
      />
      <BidsEmpty v-else />
    </Transition>
  </InsideContent>
</template>
<script>
import { mapGetters } from 'vuex';

import { CAMPAIGN_BIDS } from '@/store/types';
import campaignId from '@/mixins/advertisement/campaignId';
import InsideContent from '@@/common/layout/InsideContent';
import CardApiError from '@@/common/CardApiError';
import BidsContent from './BidsContent';
import BidsEmpty from './BidsEmpty';

import Card from '@@/common/Card';

export default {
  name: 'Bids',

  components: {
    InsideContent,
    BidsContent,
    BidsEmpty,
    CardApiError,
    Card,
  },
  mixins: [campaignId],
  data() {
    return {
      isLoading: true,
      apiError: false,

      filters: {
        range: 'last-week',
      },
    };
  },
  computed: {
    ...mapGetters({
      data: CAMPAIGN_BIDS,
    }),
  },
  created() {
    this.getBids();
  },
  methods: {
    getBids() {
      this.isLoading = true;
      this.apiError = false;
      return this.$store
        .dispatch(CAMPAIGN_BIDS, {
          campaignId: this.campaignId,
          range: this.filters.range,
        })
        .catch(err => {
          this.$message.error(err.message);
          this.apiError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
